import { useEffect, useState } from "react";
import { Menu, MorePageMenu, Plaque, SubscriptionDetails } from "@/components";
import { useGetUserMutation } from "@/store/usersApi";
import { tg } from "@/constants/telegram";
import { SelectSample } from "@/entities/user";
import { useYandexMetrika, GOALS } from "@/hooks/useYandexMetrika";
import { useAppSelector } from "@/shared/hooks";
import fondLogo from "@/assets/img/fond-innovatsiy-logo.png";

const MENU_ACTIVE_ITEM = 2;
const SUBSCRIPTION_LINK = "/subscription";

export const MorePage = () => {
  const [getUser, { isLoading }] = useGetUserMutation();
  const { trackButtonClick, trackAction } = useYandexMetrika();

  const [userSubscription, setUserSubscription] = useState<string>("...");
  const [subscriptionInfo, setSubscriptionInfo] = useState<{
    hasActiveSubscription: boolean;
    serviceTitle?: string;
    startDate?: string;
    endDate?: string | null;
  }>({ hasActiveSubscription: false });
  const [isSubscriptionExpanded, setIsSubscriptionExpanded] = useState<boolean>(false);
  const [selectSamples, setSelectSamples] = useState<
    "Selected" | "Required ancet" | SelectSample[] | null
  >(null);
  const [initData, setInitData] = useState<string | null>(null);

  useEffect(() => {
    if (tg) {
      tg.ready();
      setInitData(tg.initData || null);
    }
  }, []);

  useEffect(() => {
    const handleCreateUser = async () => {
      // Работаем и с initData, и с JWT авторизацией
      const hasAuth = initData || localStorage.getItem("access_token");
      if (!hasAuth) return;

      try {
        const result = await getUser().unwrap();

        setSelectSamples(result?.select_samples ?? null);

        const subscription = result?.user?.subscription;
        if (subscription) {
          // Проверяем, есть ли активная подписка
          const hasActiveSubscription = subscription && (
            subscription.end_date === null || // безлимитная подписка
            new Date(subscription.end_date) > new Date() // подписка с датой окончания
          );
          
          // Сохраняем информацию о подписке
          setSubscriptionInfo({
            hasActiveSubscription,
            serviceTitle: subscription.service_title,
            startDate: subscription.start_date,
            endDate: subscription.end_date
          });
          
          if (hasActiveSubscription) {
            setUserSubscription(subscription.service_title);
          } else {
            setUserSubscription("Нет активной подписки");
          }
        } else {
          setSubscriptionInfo({ hasActiveSubscription: false });
          setUserSubscription("Нет подписки");
        }

      } catch (err) {
        console.error("Ошибка получения пользователя:", err);
        setSelectSamples(null);
      }
    };

    handleCreateUser();
  }, [initData, getUser]);

  const isNotSelected = isLoading || Array.isArray(selectSamples);

  // Функция для форматирования даты
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  // Обработчик клика по блоку подписки
  const handleSubscriptionClick = () => {
    if (subscriptionInfo.hasActiveSubscription) {
      // Отслеживаем просмотр подписки
      trackAction(GOALS.ACTION_SUBSCRIPTION_VIEWED, {
        hasActiveSubscription: subscriptionInfo.hasActiveSubscription,
        serviceTitle: subscriptionInfo.serviceTitle,
        isExpanded: !isSubscriptionExpanded
      });
      
      setIsSubscriptionExpanded(!isSubscriptionExpanded);
    } else {
      // Отслеживаем переход к выбору подписки
      trackButtonClick(GOALS.BUTTON_VIEW_SUBSCRIPTION, {
        hasActiveSubscription: false
      });
    }
  };

  return (
    <div className="more-page">
      <Menu active={MENU_ACTIVE_ITEM} />
      
      {/* Блок подписки */}
      <div>
        <Plaque
          link={subscriptionInfo.hasActiveSubscription ? "" : SUBSCRIPTION_LINK}
          title="Подписка"
          text={userSubscription}
          onClick={subscriptionInfo.hasActiveSubscription ? handleSubscriptionClick : undefined}
        />
        
        {/* Детальная информация о подписке */}
        {subscriptionInfo.hasActiveSubscription && isSubscriptionExpanded && subscriptionInfo.serviceTitle && (
          <SubscriptionDetails
            serviceTitle={subscriptionInfo.serviceTitle}
            startDate={subscriptionInfo.startDate}
            endDate={subscriptionInfo.endDate}
          />
        )}
      </div>
      
      <MorePageMenu disabled={isNotSelected} />

      {/* Логотип Фонда содействия инновациям */}
      <div style={{ display: "flex", justifyContent: "center", padding: "50px 50px" }}>
        <img
          src={fondLogo}
          alt="Фонд содействия инновациям"
          style={{
            minWidth: "150px",
            width: "clamp(150px, 40vw, 300px)",
            maxWidth: "100%",
            height: "auto",
          }}
        />
      </div>
    </div>
  );
};

